import { ALERTS_PAGES } from "./pages"

const ALERTS_PATHS: string[] = Object.keys(ALERTS_PAGES)

export const routing = (route: string, location: string, back: boolean = false, page?: string) => {
  let path = route
  const endOfPath = location.split("/").pop()

  if (!back && typeof page !== "string" && endOfPath && ALERTS_PATHS.includes(endOfPath)) {
    if (path.endsWith("/")) path = path.slice(0, -1)
    return path + "/" + endOfPath
  }

  if (page) {
    if (path.endsWith("/")) path = path.slice(0, -1)

    return path + "/" + page
  }

  return path
}
